// Live Stripe Payment Links. Shared in emails as app.bringonboard.io/pay/<plan> so a link can be changed in one place.
const PAYMENT_LINKS = {
    starter: "https://buy.stripe.com/aFa4gs3QN5VWbKvfhRao803",
    pro: "https://buy.stripe.com/5kQ3codrnckk6qb7Ppao804",
    scale: "https://buy.stripe.com/dRmfZa4URckk15RedNao805",
};
const PAY_PATH_PREFIX = "/pay/";
const PRICING_PAGE_URL = "https://bringonboard.io";
/**
 * The Stripe Payment Link for a /pay/<plan> path, or null for any other path. Gmail can glue invisible characters
 * (zero-width spaces) or punctuation onto a pasted link, which breaks a Stripe link outright; keeping only the letters
 * of the plan makes /pay/starter%E2%80%8B still reach Starter. The query string passes through, so Stripe's
 * ?prefilled_email= keeps working.
 */
export const getPaymentLinkRedirect = (pathname, search) => {
    if (!pathname.startsWith(PAY_PATH_PREFIX))
        return null;
    const plan = decodeURIComponent(pathname.slice(PAY_PATH_PREFIX.length))
        .toLowerCase()
        .replace(/[^a-z]/g, "");
    const paymentLink = PAYMENT_LINKS[plan];
    if (!paymentLink)
        return PRICING_PAGE_URL;
    return `${paymentLink}${search}`;
};
